import { Button, Grid, Modal, makeStyles } from '@material-ui/core';
import { useState } from 'react';
import { connect } from 'react-redux';
import { fetchTagsByUser } from '../../../redux/actions/flag-actions';
import { setTimeProgress } from '../../../redux/actions/player-actions';
import { firebase } from '../../../firebase';
import { ReactComponent as IconMyFlags } from '../../../images/icon-my-flags-highlight.svg';
import highlightDownActiveButton from '../../../images/icon-thumbs-down-active.png';
import highlightDownButton from '../../../images/icon-thumbs-down.png';
import highlightUpActiveButton from '../../../images/icon-thumbs-up-active.png';
import highlightUpButton from '../../../images/icon-thumbs-up.png';
import ProgressBar from '../../../components/ProgressBar';
import CaptureWithComment from '../../../components/highlight/CaptureWithComment';
import CaptureWithTag from '../../../components/highlight/CaptureWithTag';
import FlagIcon from '@material-ui/icons/Flag';
import { Check } from '@material-ui/icons';
import { AccessTime } from '@material-ui/icons';
import { Clear } from '@material-ui/icons';

import '../styles/capture-flags.css';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '5px'
    },
    '*::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255)',
      borderRadius: '8px'
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ededef'
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

const CaptureWithJudgementModal = ({
  open,
  onClose,
  track,
  playerDocument,
  fetchTags,
  takeHighlight,
  saveFlagWithTag,
  tags,
  setTimeProgress_disp
}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [inputTagName, setInputTagName] = useState('');
  const [inputCommentName, setInputCommentName] = useState('');
  const [radioButtonValue, setRadioButtonValue] = useState('');
  const [tagError, setTagError] = useState({
    hasError: false,
    errorMessage: ''
  });
  const [up, setUp] = useState(false);
  const [down, setDown] = useState(false);
  const [buttonTitle, setButtonTitle] = useState('Add a Comment');
  const judgementTags = ['Agree', 'Concern', 'Follow up'];
  const judgementIcons = {
    'Agree': <Check style={{ verticalAlign: 'middle', color: 'var(--color-light-green)', fontSize: 20, marginRight: 12 }} />,
    'Concern': <Clear style={{ verticalAlign: 'middle', color: 'var(--color-error-red)', fontSize: 20, marginRight: 12 }} />,
    'Follow up': <AccessTime style={{ verticalAlign: 'middle', color: 'var(--color-warning-yellow)', fontSize: 20, marginRight: 12 }} />
  }
  const [judgement, setJudgement] = useState('');

  const renderModalCloseIcon = () => {
    return (
      <Grid
        item
        xs={12}
        className="capture-flags-modal__header-btn"
        style={{ textAlign: 'right' }}
      >
        <Button onClick={handleClose} style={{color: 'var(--color-soft-gray)'}}>x</Button>
      </Grid>
    );
  };

  const handleClose = () => {

    onClose();
    setActiveStep(0);
    setInputTagName('');
    setInputCommentName('');
    setRadioButtonValue('');
    setUp(false);
    setDown(false);
    setButtonTitle('Add a Comment');
    setTimeProgress_disp(0);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleDirectClose = (judgement = false) => {
    if (judgement) {
      saveFlagWithTag(judgement, undefined);
    } else if (up) {
      saveFlagWithTag('UPTAG', undefined);
    } else if (down) {
      saveFlagWithTag('DOWNTAG', undefined);
    } else {
      takeHighlight();
    }
    handleClose();
  };

  const handleClickJudgement = (value) => {
    setJudgement(value);
    handleDirectClose(value);

  }

  const handleClickUp = () => {
    setUp(!up);
    setDown(false);
    if (up && !down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Add a Comment');
    }
    setTimeProgress_disp(0);
  };

  const handleClickDown = () => {
    setUp(false);
    setDown(!down);
    if (!up && down) {
      setButtonTitle('Comment / Tag');
    } else {
      setButtonTitle('Add a Comment');
    }
    setTimeProgress_disp(0);
  };

  const handleButtonTagComment = async () => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await fetchTags(token);
    }
    setActiveStep(1);
  };

  const handleTagInputChange = (event) => {
    const { value } = event.target;
    setRadioButtonValue(null);
    setInputTagName(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  const handleCommentInputChange = (event) => {
    const { value } = event.target;
    setInputCommentName(value);
  };

  const handleRadioChange = (value) => {
    setInputTagName(value);
    setRadioButtonValue(value);
    setTagError({ hasError: false, errorMessage: '' });
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEscapeKeyDown
    >
      <div className="capture-flags-modal">
        {activeStep === 0 ? (
          <>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: '10%' }}
            >
              <Grid item xs={8}>
                
                <div style={{ fontSize: 'large', color: '#EDEEEF' }}>
                   <FlagIcon style={{ verticalAlign: 'text-bottom', fontSize: 20, marginRight: 12 }} />
                  Flagging this excerpt
                </div>
              </Grid>
            </Grid>
            <Grid style={{ textAlign: 'center', marginTop: 20 }}>
                <Grid item xs={12} style={{fontWeight: 200, marginTop: 20}}>
                  Select a judgement if appropriate:
                </Grid>

                  {judgementTags.map((tag) => (
                  <Grid item xs={12} style={{ marginTop: '10px' }}>
                  <Button
                    className="judgement-btn"
                    onClick={() => handleClickJudgement(tag)}
                  >
                    <div style={{width: 100, textAlign: 'left'}}>{judgementIcons[tag]} {tag}</div>
                  </Button>
                  <br />
                </Grid>
                ))}
            </Grid>
            {(playerDocument.isShareable !== undefined &&
              playerDocument.isShareable) ||
            playerDocument.showThumbs ||
            (playerDocument.sourceUserId !== undefined &&
              playerDocument.sourceUserId !== null) ? (
              <Grid
                container
                justifyContent="space-around"
                alignItems="center"
                style={{ marginTop: '20px' }}
              >
                {/* {judgementTags.map((tag) => (
                  <Grid item xs={2}>
                  <Button
                    className="highlighting-modal-btn"
                    onClick={() => handleClickJudgement(tag)}
                  >
                    {tag}
                  </Button>
                </Grid>
                ))} */}


                <Grid item xs={2}>
                  <Button
                    className="highlighting-modal-btn"
                    onClick={handleClickUp}
                  >
                    <img
                      src={up ? highlightUpActiveButton : highlightUpButton}
                    />
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    className="highlighting-modal-btn"
                    onClick={handleClickDown}
                  >
                    <img
                      src={
                        down ? highlightDownActiveButton : highlightDownButton
                      }
                    />
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    className="add-comment-modal-btn"
                    onClick={handleButtonTagComment}
                    style={{ width: '100%' }}
                    size='small'
                  >
                    <div>{buttonTitle}</div>
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ marginTop: '20px' }}
              >
                <Grid item>
                  <Button
                    className="add-comment-modal-btn"
                    onClick={handleButtonTagComment}
                    style={{ width: '100%' }}
                    size='small'
                  >
                    <div>{buttonTitle}</div>
                  </Button>
                </Grid>
              </Grid>
            )}
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: '10%', marginBottom: '20px' }}
            >
              <Grid item xs={8}>
                <div
                  className="button-bar"
                  onClick={handleDirectClose}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="btn__title">Closing...</div>
                  {up ? (
                    <ProgressBar
                      tag={'UPTAG'}
                      saveFlag={saveFlagWithTag}
                      onComplete={handleClose}
                    />
                  ) : down ? (
                    <ProgressBar
                      tag={'DOWNTAG'}
                      saveFlag={saveFlagWithTag}
                      onComplete={handleClose}
                    />
                  ) : (
                    <ProgressBar
                      takeHighlight={takeHighlight}
                      onComplete={handleClose}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {/* Modal view step 1 for adding tags and/or comments */}
            {renderModalCloseIcon()}
            {up ? (
              <CaptureWithComment
                tag={'UPTAG'}
                inputCommentName={inputCommentName}
                handleCommentInputChange={handleCommentInputChange}
                onClose={handleClose}
                saveFlagWithComment={saveFlagWithTag}
              />
            ) : down ? (
              <CaptureWithComment
                tag={'DOWNTAG'}
                inputCommentName={inputCommentName}
                handleCommentInputChange={handleCommentInputChange}
                onClose={handleClose}
                saveFlagWithComment={saveFlagWithTag}
              />
            ) : (
              <CaptureWithTag
                edit={false}
                tags={tags}
                inputTagName={inputTagName}
                inputCommentName={inputCommentName}
                radioButtonValue={radioButtonValue}
                handleTagInputChange={handleTagInputChange}
                handleCommentInputChange={handleCommentInputChange}
                handleRadioChange={handleRadioChange}
                onClose={handleClose}
                saveFlagWithTag={saveFlagWithTag}
                tagError={tagError}
                setTagError={setTagError}
              />
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (store) => {
  return {
    tags: store.flag.tags,
    timeProgress: store.player.timeProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTags: (token) => {
      dispatch(fetchTagsByUser(token));
    },
    setTimeProgress_disp: (value) => {
      dispatch(setTimeProgress(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaptureWithJudgementModal);
